import { useCreateOrUpdateTirageInAuction } from "@/api/related-fields";
import { FieldConfig } from "@/config/forms/general";
import { TirageInAuction } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const TirageInAuctionDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: TirageInAuction;
  queryId: string;
  type: string;
}) => {
  const schema = z.object({
    tirageDansVentesDescriptionNumeroLot: z.string().optional(),
    tirageDansVentesDescriptionReproduitPage: z.string().optional(),
    tirageDansVentesDescriptionEstimationHaute: z.string().optional(),
    tirageDansVentesDescriptionEstimationBasse: z.string().optional(),
    tirageDansVentesDescriptionVendu: z.boolean().optional(),
    tirageDansVentesDescriptionResultatNonListe: z.boolean().optional(),
    tirageDansVentesDescriptionNonVenu: z.boolean().optional(),
    tirageDansVentesDescriptionNonVendu: z.boolean().optional(),
    tirageDansVentesDescriptionNonReproduit: z.boolean().optional(),
    tirageDansVentesDescriptionRetire: z.boolean().optional(),
    tirageDansVentesDescriptionMiseAPrix: z.string().optional(),
    tirageDansVentesDescriptionPrixMarteau: z.string().optional(),
    tirageDansVentesDescriptionPrixAvecFrais: z.string().optional(),
    tirageDansVentesDescriptionNotes: z.string().optional(),
    auction: z.object({
      ventesDescriptionNumeroVente: z.string().optional(),
      ventesDescriptionResume: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateTirageInAuction } =
    useCreateOrUpdateTirageInAuction(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      auction: data.auction,
      tirageDansVentesDescriptionNumeroLot:
        data.tirageDansVentesDescriptionNumeroLot,
      tirageDansVentesDescriptionReproduitPage:
        data.tirageDansVentesDescriptionReproduitPage,
      tirageDansVentesDescriptionEstimationHaute:
        data.tirageDansVentesDescriptionEstimationHaute,
      tirageDansVentesDescriptionEstimationBasse:
        data.tirageDansVentesDescriptionEstimationBasse,
      tirageDansVentesDescriptionVendu: data.tirageDansVentesDescriptionVendu,
      tirageDansVentesDescriptionResultatNonListe:
        data.tirageDansVentesDescriptionResultatNonListe,
      tirageDansVentesDescriptionNonVenu:
        data.tirageDansVentesDescriptionNonVenu,
      tirageDansVentesDescriptionNonVendu:
        data.tirageDansVentesDescriptionNonVendu,
      tirageDansVentesDescriptionNonReproduit:
        data.tirageDansVentesDescriptionNonReproduit,
      tirageDansVentesDescriptionRetire: data.tirageDansVentesDescriptionRetire,
      tirageDansVentesDescriptionMiseAPrix:
        data.tirageDansVentesDescriptionMiseAPrix,
      tirageDansVentesDescriptionPrixMarteau:
        data.tirageDansVentesDescriptionPrixMarteau,
      tirageDansVentesDescriptionPrixAvecFrais:
        data.tirageDansVentesDescriptionPrixAvecFrais,
      tirageDansVentesDescriptionNotes: data.tirageDansVentesDescriptionNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateTirageInAuction({
      id: data.id,
      tirageId: data.tirage.id,
      auctionId: data.auction.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default TirageInAuctionDrawer;
